export default __webpack_public_path__ + "static/media/ChikwadoMbalagu.440617b3.svg";